(() => {
  const DESKTOP_BREAKPOINT = 990;
  const CLOSE_DELAY = 280;

  function initPremiumMenus(root = document) {
    const items = root.querySelectorAll('.wp-premium-menu-item');

    items.forEach((item) => {
      if (item.dataset.wpHoverReady === 'true') return;

      const trigger = item.querySelector(':scope > .megamenu_megamenu > .dt-sc-nav-link');
      const panel = item.querySelector(':scope .mega-menu__content');

      if (!trigger || !panel) return;

      item.dataset.wpHoverReady = 'true';
      let closeTimer;

      const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

      const openMenu = () => {
        if (!isDesktop()) return;
        window.clearTimeout(closeTimer);
        item.classList.add('wp-menu-open');
        panel.style.setProperty('display', 'block', 'important');
      };

      const scheduleClose = () => {
        if (!isDesktop()) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          item.classList.remove('wp-menu-open');
          panel.style.removeProperty('display');
        }, CLOSE_DELAY);
      };

      trigger.addEventListener('mouseenter', openMenu);
      trigger.addEventListener('focus', openMenu);
      trigger.addEventListener('mouseleave', scheduleClose);

      panel.addEventListener('mouseenter', openMenu);
      panel.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('focusin', openMenu);
      panel.addEventListener('focusout', scheduleClose);

      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', scheduleClose);

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          item.classList.remove('wp-menu-open');
          panel.style.removeProperty('display');
          trigger.focus();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initPremiumMenus());

  document.addEventListener('shopify:section:load', (event) => {
    initPremiumMenus(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initPremiumMenus();
  });
})();
